import request from '../Functions/ajax/request'

export default async function HomeLoader ({ params })
{
	return { params, page: getPage({ params }) };
}

async function getPage ()
{
	try
	{
		var { data, banners } = await request('/articles/get-articles-en-avant')
		.config({ min_req_time: 0 })
		.post({ banners: true });
	}
	catch (e)
	{
		data = [];
	}

	return { articles_en_avant: data || [], banners: banners };
}